/**
 * LoadingSpinner Atom
 * Reusable loading spinner indicator. Used across 7+ files.
 * Pure presentational — no state, no API.
 */
import React from 'react';
import { cn } from '../ui/utils';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** When true, wraps spinner in a flex centered container with py-8 */
  centered?: boolean;
  className?: string;
  /** Additional class for the wrapper div (only used when centered=true) */
  wrapperClassName?: string;
}

const sizeClasses: Record<string, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-b-2',
  lg: 'h-12 w-12 border-b-2',
};

export function LoadingSpinner({ size = 'md', centered = false, className, wrapperClassName }: LoadingSpinnerProps) {
  const spinner = (
    <div className={cn('animate-spin rounded-full border-fuchsia-600', sizeClasses[size], className)} />
  );

  if (centered) {
    return (
      <div className={cn('flex items-center justify-center py-8', wrapperClassName)}>
        {spinner}
      </div>
    );
  }

  return spinner;
}
